import { render, staticRenderFns } from "./GroupIconGrabber.vue?vue&type=template&id=baccf844"
import script from "./GroupIconGrabber.vue?vue&type=script&lang=js"
export * from "./GroupIconGrabber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports